<template>
  <div id="info-modal" class="modal" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content modal-content--info">
        <div class="modal-header">
          <h5 class="modal-title">{{ $t("title") }}</h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <p v-html="$t('body')" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "InfoModal"
};
</script>

<i18n>
{
  "cs": {
    "title": "Online kurzy živě",
    "body": "Vzdělávání pro profíky včetně živého akreditovaného trenéra přichází k vám domů. Do pracoven, do obýváků i kuchyní. Vy nikam nemusíte.<br /><br />Jednoduše. Bezpečně. Online."
  },
  "en": {
    "title": "Live on-line courses",
    "body": "Live on-line courses. Education for professionals with a live accredited trainer from the comfort and safety of your home.<br /><br />Simple.  Safe.  Online."
  }
}
</i18n>
